import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Actions as ADMINACTIONS } from '../../../store/actions/adminActions';
import Breadcrumb from '../../Common/Breadcrumb';
import ClosestAirportListTable from './ClosestAirportListTable';
import { Card } from '../../ui/card';

const items = [{ label: 'Closest Airport', link: '/admin/closestAirport' }];

const ClosestAirportList = ({ toggleModal, itemCount, filterSize }) => {
  const [page, setPage] = useState(1);
  const [tableSize, setTableSize] = useState(filterSize[0]);
  const [totalItems, setTotalItems] = useState(null);
  const total = totalItems ? totalItems : itemCount;

  return (
    <div>
      <div className='flex flex-row justify-between items-center'>
        <Breadcrumb items={items} />

        {/* Uncomment if needed
        <div>
          <Button 
            variant="default" 
            onClick={() => toggleModal(true, 'entities-table-add', null)}
          >
            Add an Airport
          </Button>
        </div> */}
      </div>

      <Card className='w-full'>
        <ClosestAirportListTable
          page={page}
          setPage={setPage}
          setTableSize={setTableSize}
          tableSize={tableSize}
          setTotalItems={setTotalItems}
          totalItems={total}
        />
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    itemCount: state.admin?.indexItems?.totalCount,
    filterSize: state.admin.filterSize,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleModal: (status, action, item, notAutoClose) =>
    dispatch(ADMINACTIONS.toggleModal(status, action, item, notAutoClose)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClosestAirportList);
